/* Recipes listing — client-side search + tag filter. */
(function () {
  var root = document.querySelector('[data-recipes-listing]');
  if (!root) return;
  var search = root.querySelector('[data-recipes-search]');
  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-recipe-card]'));
  var chips = Array.prototype.slice.call(root.querySelectorAll('[data-filter]'));
  var empty = root.querySelector('[data-recipes-empty]');
  var activeTag = '';

  function apply() {
    var q = (search.value || '').trim().toLowerCase();
    var shown = 0;
    cards.forEach(function (c) {
      // exact tag match (tags are comma-joined); search stays substring on title+tags
      var cardTags = (c.dataset.tags || '').split(',');
      var matchesTag = !activeTag || cardTags.indexOf(activeTag) > -1;
      var matchesQ = !q || (c.dataset.title || '').indexOf(q) > -1 || (c.dataset.tags || '').indexOf(q) > -1;
      var show = matchesTag && matchesQ;
      c.style.display = show ? '' : 'none';
      if (show) shown++;
    });
    if (empty) empty.hidden = shown > 0;
  }

  if (search) search.addEventListener('input', apply);
  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      activeTag = chip.dataset.filter;
      chips.forEach(function (c) { c.classList.toggle('is-active', c === chip); });
      apply();
    });
  });

  // Honor ?q= and ?tag= passed in from a recipe page's discovery bar.
  var params = new URLSearchParams(window.location.search);
  var qp = params.get('q');
  var tp = params.get('tag');
  if (qp && search) search.value = qp;
  if (tp) activeTag = tp.toLowerCase();
  chips.forEach(function (c) { c.classList.toggle('is-active', (c.dataset.filter || '') === activeTag); });
  apply();
})();
